import axios from "axios";
export default class axiosClient {
    async publishItPark(id) {
        const headers = {
            accept: "application/json"
        };
        const resp = await axios.post("api/it_parks/publish/" + id, {}, {
            headers: headers
        });
        return resp.data;
    }
    async uploadItPark(park) {
        const headers = {
            accept: "application/json"
        };
        if (park.id) {
            const resp = await axios.put("api/it_parks/" + park.id, park, {
                headers: headers
            });
            return resp.data;
        }
        const resp = await axios.post("api/it_parks", park, {
            headers: headers
        });
        return resp.data;
    }
    async deleteItPark(id) {
        const headers = {
            accept: "application/json"
        };
        await axios.delete("api/it_parks/" + id, {
            headers: headers
        });
    }
    async getItPark(id) {
        const headers = {
            accept: "application/json"
        };
        const resp = await axios.get("api/it_parks/" + id, {
            headers: headers
        });
        return resp.data;
    }
    async getItParks() {
        const headers = {
            accept: "application/json"
        };
        const resp = await axios.get("api/it_parks", {
            headers: headers
        });
        return resp.data;
    }
}
